let request = require('../js/request.js')
let localUserInfo = require('../js/utility/utility.js').localUserInfo

// 登录相关API
let loginApi = {
  // 用户登录
  userLogin: function (data) {
    return request.post('/login', data)
  },
  // 根据公司代号获取公司信息
  getCompanyInfo: function (data) {
    return request.post('/Login/getCompanyInfo', data)
  },
  // 忘记密码
  forgetPassword: function (data) {
    return request.post('/login/forgetPassword', data)
  },
  // 修改密码
  changeUserPassword: function (data) {
    return request.post('/user/changeUserPassword', data)
  },
  // 登录设置
  loginSetting: function (data) {
    return request.post('/user/loginSetting', data)
  },
  // 支付设置
  paySetting: function (data) {
    return request.post('/user/WeChatPaySetting', data)
  },
}

// 菜单相关API
let navApi = {
  // 获取菜单列表
  getUserAuthList: function () {
    return request.post('/user/menu')
  }
}

// 仪表盘相关API
let mapApi = {
  // 获取地区、空间的设备数量
  getSpaceDeviceCount: function (data) {
    return request.post('/appearance/getSpaceDeviceCount', data)
  },
  // 查询公司设备数量接口
  searchSpace: function (data) {
    return request.post('/appearance/searchSpace', data)
  },
  // 仪表盘设备信息分布
  analyze: function () {
    return request.post('/appearance/analyze')
  },
}

// 用户管理相关API
let userApi = {
  /* 组织管理 */
  // 获取部门列表 
  getDepartmentList: function () {
    return request.post('/user/getDepartmentList')
  },
  // 更新（新增/修改/删除）部门
  updateDepartment: function (data) {
    return request.post('/user/updateDepartment', data)
  },
  // 获取所有部门一级列表
  getAllDepartment: function (data) {
    return request.post('/user/getAllDepartment', data)
  },
  // 获取部门详情
  getDepartmentInfo: function (data) {
    return request.post('/user/getDepartmentInfo', data)
  },
  // 获取角色列表
  getRoleList: function (data) {
    return request.post('/user/getRoleList', data)
  },
  // 新增/修改角色
  updateRole: function (data) {
    return request.post('/user/updateRole', data)
  },
  // 删除角色
  deleteRole: function (data) {
    return request.post('/user/deleteRole', data)
  },
  // 获取角色权限详情
  getRoleAuth: function (data) {
    return request.post('/user/getRoleAuth', data)
  },
  // 更新角色权限
  updateRoleAuth: function (data) {
    return request.post('/user/updateRoleAuth', data)
  },
  // 获取角色用户
  getRoleUser: function (data) {
    return request.post('/user/getRoleUser', data)
  },
  // 更新角色用户
  updateRoleUser: function (data) {
    return request.post('/user/updateRoleUser', data)
  },
  // 获取用户列表
  getUserList: function (data) {
    return request.post('/user/getUserList', data)
  },
  // 更新（添加/修改）用户
  updateUser: function (data) {
    return request.post('/user/updateUser', data)
  },
  // 修改用户状态
  changeUserStatus: function (data) {
    return request.post('/user/changeUserStatus', data)
  },
  // 上传图片
  uploadImage: function (data) {
    return request.post('/user/uploadImage', data)
  },
  // 获取用户生物特征
  getUserProfile: function (data) {
    return request.post('/user/getUserProfile', data)
  },
  // 添加/更新/删除用户生物特征
  updateUserProfile: function (data) {
    return request.post('/user/updateUserProfile', data)
  },
  // 获取登录设置信息
  getPayConfig: function () {
    return request.post('/user/getPayConfig')
  },
  // 获取临时用户列表
  getTemporaryList: function (data) {
    return request.post('/TemporaryUser/getUserList', data)
  },
  // 修改临时用户状态
  changeTempStatus: function (data) {
    return request.post('/TemporaryUser/changeUserStatus', data)
  },
  // 临时用户关联的设备
  getUserDevice: function (data) {
    return request.post('/TemporaryUser/getUserDevice', data)
  },
  // 临时用户关联的设备
  getUserDevice: function (data) {
    return request.post('/TemporaryUser/getUserDevice', data)
  },
  // 临时用户的生物特征
  getTempProfile: function (data) {
    return request.post('/TemporaryUser/getUserProfile', data)
  },
  // 批量导入用户
  batchAddUser: function (data) {
    return request.post('/user/batchAddUser', data)
  },
}

// 场景管理相关API
let sceneApi = {
  /* 场景列表 */
  // 获取场景列表
  space: function (data) {
    return request.post('/space', data)
  },
  // 新增场景
  addSpace: function (data) {
    return request.post('/space/addSpace', data)
  },
  // 获取街道列表
  getStreetList: function (data) {
    return request.post('/space/getStreetList', data)
  },
  // 根据街道获取空间列表
  getSpaceListByStreet: function (data) {
    return request.post('/space/getSpaceListByStreet', data)
  },
  // 获取空间详情
  getSpaceInfo: function (data) {
    return request.post('/space/getSpaceInfo', data)
  },
  // 修改空间
  updateSpace: function (data) {
    return request.post('/space/updateSpace', data)
  },
  // 修改空间的下级空间
  updateChildSpace: function (data) {
    return request.post('/space/updateChildSpace', data)
  },
  // 删除空间
  deleteSpace: function (data) {
    return request.post('/space/deleteSpace', data)
  },
  // 获取城市/地区列表
  getAreaList: function (data) {
    return request.commonPost('/common/area', data)
  },
  // 获取场景设备列表
  getSpaceDeviceList: function (data) {
    return request.post('/space/getSpaceDeviceList', data)
  },
  // 添加/修改设备
  updateDevice: function (data) {
    return request.post('/space/addDevice', data)
  },
  // 获取未绑定过的设备列表
  getDeviceList: function () {
    return request.post('/space/getDeviceList')
  },
  // 删除设备
  deleteDevice: function (data) {
    return request.post('/space/deleteDevice', data)
  },
  // 批量转移设备
  transferDevice: function (data) {
    return request.post('/space/transferDevice', data)
  },

}

// 授权管理相关API
let authApi = {
  // 获取授权用户列表
  getAuthorizedUserList: function (data) {
    return request.post('/authorized/getAuthorizedUserList', data)
  },
  // 获取用户列表
  getUserList: function (data) {
    return request.post('/Authorized/getUser', data)
  },
  // 添加授权用户
  addAuthorizedUser: function (data) {
    return request.post('/authorized/addAuthorizedUser', data)
  },
  // 添加设备管理员
  addDeviceAdmin: function (data) {
    return request.post('/authorized/addDeviceAdmin', data)
  },
  // 通过场景获取所有的设备
  getSpaceDeviceAll: function (data) {
    return request.post('/authorized/getSpaceDeviceAll', data)
  },
  // 批量添加授权用户
  batchAddAuthorizedUser: function (data) {
    return request.post('/authorized/batchAddAuthorizedUser', data)
  },
  // 用户列表接口
  getAdminUserList: function (data) {
    return request.post('/authorized/getUserList', data)
  },
  // 更新授权用户
  updateAuthorizedUser: function (data) {
    return request.post('/authorized/updateAuthorizedUser', data)
  },
  // 删除授权用户
  delAuthorizedUser: function (data) {
    return request.post('/authorized/delAuthorizedUser', data)
  },
  // 获取箱格授权信息
  getAuthBox: function (data) {
    return request.post('/authorized/getAuthorizeDeviceBoxInfo', data)
  },
}

// 无人仓相关API
let unmanApi = {
  // 获取配置设置列表
  getWarehouse: function (data) {
    return request.post('/Warehouse/index', data)
  },
  // 获取设备列表
  getDeviceList: function () {
    return request.post('/Warehouse/getWarehouseDeviceList')
  },

  // 新增/修改配置
  updateConfig: function (data) {
    return request.post('/warehouse/updateConfig', data)
  },
  // 删除配置
  deleteConfig: function (data) {
    return request.post('/warehouse/deleteConfig', data)
  },
  // 获取预约记录列表
  warehouseAppointment: function (data) {
    return request.post('/warehouse/warehouseAppointment', data)
  },
  // 获取无人仓子库列表
  getWarehouseLocation: function () {
    return request.post('/warehouse/getWarehouseLocation')
  },
  // 添加预约出入库
  addAppointment: function (data) {
    return request.post('/warehouse/addAppointment', data)
  },
  // 获取出入库列表
  getStorageOrder: function (data) {
    return request.post('/warehouse/getStorageOrder', data)
  },
  // 订单回调重发接口
  storageCallback: function (data) {
    return request.post('/warehouse/storageCallback', data)
  },
  // 场景设备类型列表
  getSpaceDeviceTypeList: function (data) {
    return request.post('/warehouse/getSpaceDeviceList', data)
  },
  // 获取空间父id
  getSpaceParentSpace: function (data) {
    return request.post('/space/getSpaceParentSpace', data)
  }
}

//e站相关api
let eSiteApi = {
  // 获取设备列表
  getDeviceList: function (data) {
    return request.post('/Warehouse/getWarehouseDeviceList', data)
  },
  // 获取出入库列表
  getStandList: function (data) {
    return request.post('/Estand/index', data)
  },
  // 回调重发接口
  storageCallback: function (data) {
    return request.post('/Estand/orderCallback', data)
  },
  // 获取设备名称
  getDeviceName: function (data) {
    return request.post('/Warehouse/getDeviceName', data)
  },
}

//业务中心相关API
let bussinessApi = {
  // 获取启动业务
  getBussiness: function () {
    return request.post('/bussiness/bussiness')
  },
  // 获取所有业务
  getBussinessAll: function () {
    return request.post('/bussiness/index')
  },
  // 添加/修改业务
  changeBussiness: function (data) {
    return request.post('/bussiness/updateBussiness', data)
  },
  // 通过空间id获取快递设备
  getSpaceDeviceKd: function (data) {
    return request.post('/Courier/getSpaceDeviceListByCourier', data)
  },
  // 配置快递
  configKuaidi: function (data) {
    return request.post('/Courier/addCourierAndDevice', data)
  },
  // 通过空间id获取预约设备
  getSpaceDeviceYy: function (data) {
    return request.post('/Appointment/getSpaceDeviceListByAuditor', data)
  },
  // 配置预约(旧，可删)
  // confiigYuyue: function (data) {
  // 	return request.post('/Appointment/updateAppointmentAuditor',data)
  // },
  // 配置预约
  configYuyue: function (data) {
    return request.post('/Appointment/addAppointmentAuditor', data)
  },
  // 添加/修改价格策略
  updateTactics: function (data) {
    return request.post('/tactics/updateTactics', data)
  },
  // 价格策略列表
  tacticsList: function () {
    return request.post('/tactics/index')
  },
  // 通过空间id获取扫码支付设备
  getSpaceDeviceSmzf: function (data) {
    return request.post('/tactics/getDeviceName', data)
  },
  // 配置扫码支付
  configSmzf: function (data) {
    return request.post('/tactics/configTactics', data)
  },
  // 审核记录
  auditorDeviceList: function (data) {
    return request.post('/Appointment/getAppointmentDeviceList', data)
  },
  // 修改预约状态
  auditorStatus: function (data) {
    return request.post('/Appointment/updateAppintmentStatus', data)
  },
  // 预约配置列表
  auditorLiist: function (data) {
    return request.post('/Appointment/appintmentAuditorList', data)
  },
  // 删除预约配置
  delYuyueConfig: function (data) {
    return request.post('/Appointment/deleteAppointmentAuditor', data)
  },
  // 审核人信息（单条）
  getAuditorByOne: function () {
    return request.post('/Courier/getAuditorByOne')
  },
  //释放订单
  relTrackNum: function (data) {
    return request.post('/courier/AdminResetOrder', data)
  },
  // 快递员列表
  kdCourierList: function (data) {
    return request.post('/Courier/courierList', data)
  },
  // 添加快递员
  addAuditor: function (data) {
    return request.post('/Courier/addCompanyCourier', data)
  },
  // 修改快递员状态
  statusExpress: function (data) {
    return request.post('/Courier/updateCourierStatus', data)
  },
  // 修改审核人
  updateAuditor: function (data) {
    return request.post('/Courier/updateCourierAuditor', data)
  },
  // 查看注册二维码
  lookEwmKd: function () {
    return request.post('/Courier/courierRegisterQrcode')
  },
  // 快递配置列表
  kdConfigList: function (data) {
    return request.post('/Courier/courierDeviceList', data)
  },
  // 添加快递配置列表
  addkdConfig: function (data) {
    return request.post('/Courier/addCourierDevice', data)
  },
  // 删除快递配置列表
  delkdConfig: function (data) {
    return request.post('/Courier/deleteCourierDevice', data)
  },
  // 支付记录列表
  smzfPayList: function (data) {
    return request.post('/tactics/payList', data)
  },
  // 支付开门记录
  smzforderOpenList: function (data) {
    return request.post('/tactics/orderOpenList', data)
  },
  // 开门记录列表
  smzfOpenList: function (data) {
    return request.post('/tactics/openList', data)
  },
  // 释放订单
  relIndent: function (data) {
    return request.post('/tactics/AdminResetOrder', data)
  },
  // 价格策略列表
  smzfPriceList: function (data) {
    return request.post('/tactics/index', data)
  },
  // 删除价格策略
  delSmzfPrice: function (data) {
    return request.post('/tactics/deleteTactics', data)
  },
  // 扫码支付配置列表
  smzfConfigList: function (data) {
    return request.post('/tactics/configTacticsList', data)
  },
  // 删除扫码支付配置
  delSmzfConfig: function (data) {
    return request.post('/tactics/deleteTacticsConfig', data)
  },
  // 获取设备类型
  getDeviceTypeList: function (data) {
    return request.post('/Appointment/getDeviceTypeList', data)
  },
  // 通过设备类型获取设备列表
  getDeviceListByType: function (data) {
    return request.post('/Appointment/getDeviceListByType', data)
  },
  // 审核人员配置详细信息
  getAuditorInfo: function (data) {
    return request.post('/Appointment/getAppintmentAuditorInfo', data)
  },
  // 修改审核人员
  updateAppintmentAuditor: function (data) {
    return request.post('/Appointment/updateAppintmentAuditor', data)
  },
  // 快递订单列表接口
  getCourierOrderList: function (data) {
    return request.post('/Courier/getCourierOrderList', data)
  },
  //获取快递员生物特征
  getCourierProfile: function (data) {
    return request.post('/Courier/getCourierProfile', data)
  },
  //更新快递员生物特征
  updateUserProfile: function (data) {
    return request.post('/Courier/updateUserProfile', data)
  },
  //获取扫码支付设备类型
  getConfigDeviceList: function () {
    return request.post('/tactics/getConfigDeviceList')
  },
  // 通过空间id获取扫码支付设备
  getSpaceDeviceSmzfcode: function (data) {
    return request.post('/tactics/getSpaceDeviceListByTactics', data)
  },
  // 获取盘点单号记录列表
  GetCheckStorage: function (data) {
    return request.post4s('/service/storage/GetCheckStorage.json', data)
  },
  // 获取盘点单号详情
  GetCheckStorageDetails: function (data) {
    return request.post4s('/service/storage/GetCheckStorageDetails.json', data)
  },
  // 获取快递公司列表
  GetExpress: function (data) {
    return request.post('/Courier/getExpress', data)
  },
  // 更新快递公司信息
  SaveExpress: function (data) {
    return request.post('/Courier/saveExpress', data)
  },
  // 修改快递员状态
  saveExpressStatus: function (data) {
    return request.post('/Courier/saveExpressStatus', data)
  },
  /** 仓储管理 */
  //仓库空间树形数据
  WarehouseTree: function (data) {
    return request.post4s('/service/Storage/WarehouseTree.json', data)
  },
  //获取仓库列表
  WareList: function (data) {
    return request.post4s('/service/Storage/WareList.json', data)
  },
  //添加、修改、删除仓库
  UpdateWare: function (data) {
    return request.post4s('/service/Storage/UpdateWare.json', data)
  },
  //获取库区列表
  StoreHouseList: function (data) {
    return request.post4s('/service/Storage/StoreHouseList.json', data)
  },
  //添加、修改、删除库区
  UpdateStore: function (data) {
    return request.post4s('/service/Storage/UpdateStore.json', data)
  },
  //获取货架列表
  ShelvesList: function (data) {
    return request.post4s('/service/Storage/ShelvesList.json', data)
  },
  //添加、删除货架
  UpdateShelves: function (data) {
    return request.post4s('/service/Storage/UpdateShelves.json', data)
  },
  //获取添加货架时的设备列表
  ShelvesDevicesList: function (data) {
    return request.post4s('/service/Storage/ShelvesDevicesList.json', data)
  },

  //获取产品列表
  ProductList: function (data) {
    return request.post4s('/service/Storage/ProductList.json', data)
  },
  //获取产品类型列表
  ProductTypeList: function (data) {
    return request.post4s('/service/Storage/ProductTypeList.json', data)
  },
  //更改产品类型
  UpdateProductType: function (data) {
    return request.post4s('/service/Storage/UpdateProductType.json', data)
  },
  //获取产品单位列表
  ProductUnitList: function (data) {
    return request.post4s('/service/Storage/ProductUnitList.json', data)
  },
  //更改产品单位
  UpdateProductUnit: function (data) {
    return request.post4s('/service/Storage/UpdateProductUnit.json', data)
  },
  //获取产品供应商列表
  ProductSupplierList: function (data) {
    return request.post4s('/service/Storage/ProductSupplierList.json', data)
  },
  //更改产品供应商
  UpdateProductSupplier: function (data) {
    return request.post4s('/service/Storage/UpdateProductSupplier.json', data)
  },
  //更新产品
  UpdateProduct: function (data) {
    return request.post4s('/service/Storage/UpdateProduct.json', data)
  },
  //预约列表
  BookList: function (data) {
    return request.post4s('/service/Storage/BookList.json', data)
  },
  //更改审核状态、删除预约单
  UpdateBook: function (data) {
    return request.post4s('/service/Storage/UpdateBook.json', data)
  },
  //获取产品详情
  ProductDetail: function (data) {
    return request.post4s('/service/Storage/ProductDetail.json', data)
  },
  //提交入库、出库预约单
  UpdateOrder: function (data) {
    return request.post4s('/service/Storage/UpdateOrder.json', data)
  },

  //出入库管理列表
  InOutStorageList: function (data) {
    return request.post4s('/service/Storage/InOutStorageList.json', data)
  },
  //删除出入库订单
  UpdateInOutStorage: function (data) {
    return request.post4s('/service/Storage/UpdateInOutStorage.json', data)
  },
  //仓储订单列表
  StorageOrder: function (data) {
    return request.post4s('/service/Storage/StorageOrder.json', data)
  },
  //产品bom列表
  ProductBomList: function (data) {
    return request.post4s('/service/Storage/ProductBomList.json', data)
  },
  //批量添加产品Bom
  BatchAddProductBom: function (data) {
    return request.post4s('/service/Storage/BatchAddProductBom.json', data)
  },
  //修改产品bom
  SaveProductBom: function (data) {
    return request.post4s('/service/Storage/SaveProductBom.json', data)
  },
  //产品授权列表
  ProductAuthList: function (data) {
    return request.post4s('/service/Storage/ProductAuthList.json', data)
  },
  //添加产品授权
  AddProductAuth: function (data) {
    return request.post4s('/service/Storage/AddProductAuth.json', data)
  },
  //取消产品授权
  DelProductAuth: function (data) {
    return request.post4s('/service/Storage/DelProductAuth.json', data)
  },

  getAppointmentSpaceDeviceList: function(data) {
    return request.post('/appointment/getAppointmentSpaceDeviceList', data)
  },
  
}

//设备中心相关API
let deviceApi = {
  // 获取所有类型列表（空间和供应链）
  getEquipmentAllTypeList: function (data) {
    return request.post('/Equipment/getEquipmentAllTypeList', data)
  },
  // 获取启动业务(智慧类型列表)
  getEquipment: function (data) {
    return request.post('/Equipment/getEquipmentTypeList', data)
  },
  // 获取设备列表
  getEquipmentDeviceList: function (data) {
    return request.post('/Equipment/getEquipmentSpaceDeviceList', data)
  },
  // 获取电表统计
  getWattMetter: function () {
    return request.post('/Equipment/getEmeterData')
  },
  // 按年月日获取用电统计
  getEmeterYearMonthDay: function (data) {
    return request.post('/Equipment/getEmeterYearMonthDay', data)
  },
  // 电表读数列表
  getEmeterByDayList: function (data) {
    return request.post('/Equipment/getEmeterByDayList', data)
  },
  // 获取导出地址
  expEmeterByDayList: function (data) {
    return request.post('/Equipment/expEmeterByDayList', data)
  },
  // 设备开关
  deviceControl: function (data) {
    return request.post('/Equipment/deviceControl', data)
  },
  // 获取设备箱格列表
  getDeviceBoxList: function (data) {
    return request.post('/Equipment/getDeviceBoxList', data)
  },
  // 获取所有箱格信息
  getBoxMesList: function (data) {
    return request.post4s('/service/BasicBox/BoxMesApi', data)
  },

  // 获取开门记录列表
  deviceRecord: function (data) {
    return request.post('/Equipment/deviceRecord', data)
  },
  // 生成小程序二维码
  previewImg: function (data) {
    // console.log('data', data)
    // 当前登录的小程序（cmcc为小移智控）
    data.program_type = localUserInfo.getItem().program_type
    // console.log('data', data)
    return request.commonPost('/Common/Qrcode/createQrCodeImage', data)
  },
  // 获取设备位置
  getDeviceLocation: function (data) {
    return request.post('/Equipment/getDeviceLocation', data)
  },
  // 智能售卖柜-设置设备配置的信息
  setDeviceConfig: function (data) {
    return request.post('/Equipment/setDeviceConfig', data)
  },
  // 智能售卖柜-获取设备配置的信息
  getDeviceConfig: function (data) {
    return request.post('/Equipment/getDeviceConfig', data)
  },
  //箱格操作
  batchSetDevice: function (data) {
    return request.post('/Equipment/batchSetDevice', data)
  },
  //获取设备授权记录
  getDeviceAuthRecords: function (data) {
    return request.post('/Equipment/getDeviceAuthRecords', data)
  },
  //获取设备操作记录（车位锁）
  getDeviceOpenRecords: function (data) {
    return request.post('/Equipment/getDeviceOpenRecords', data)
  },
  // 获取设备操作记录
  getOperateList: function (data) {
    return request.post('/Equipment/getOperateList', data)
  },
  // 导出设备操作记录
  exportOperateList: function (data) {
    return request.post('/Equipment/exportOperateList', data)
  },
  // 设置消毒一体机运行模式
  setThAioRunMode: function (data) {
    return request.post('/Equipment/setThAioRunMode', data)
  },
  // 获取漏水传感器线路
  getWaterleakageRoad: function (data) {
    return request.post('/Equipment/getWaterleakageRoad', data)
  },
  // 设置漏水传感器线路
  setWaterleakageRoad: function (data) {
    return request.post('/Equipment/setWaterleakageRoad', data)
  },
  // 获取温湿度采集器的预警情况
  getExceptionList: function (data) {
    return request.post('/Equipment/getExceptionList', data)
  },
  // 获取温湿度采集器的预警类型
  getExceptionTypeList: function () {
    return request.post('/Equipment/getExceptionTypeList')
  },
  // 获取设备温湿度预警上下限
  getTempHumiLimit: function (data) {
    return request.post('/Equipment/getTempHumiLimit', data)
  },
  // 设置设备温湿度预警上下限
  setTempHumiLimit: function (data) {
    return request.post('/Equipment/setTempHumiLimit', data)
  },
  // 按时间类型查询设备平均温湿度
  getTempHumiByDate: function (data) {
    return request.post('/Equipment/getTempHumiByDate', data)
  },
  //设置密码过期信息
  UpdateDeivcePasswordInfo: function (data) {
    return request.post4s('/service/DeviceCenter/UpdateDeivcePasswordInfo.json', data)
  },
  //检查设备管理员账号
  CheckDeviceAccount: function (data) {
    return request.post4s('/service/DeviceCenter/CheckDeviceAccount.json', data)
  },
  //修改密码保险柜的密码信息
  UpdateDeivcePassword: function (data) {
    return request.post4s('/service/DeviceCenter/UpdateDeivcePassword.json', data)
  },
  //密码保险柜的预警记录
  ExceptionList: function (data) {
    return request.post4s('/service/DeviceCenter/ExceptionList.json', data)
  },
  //密码保险柜的开门记录
  OpenLogList: function (data) {
    return request.post4s('/service/DeviceCenter/OpenLogList.json', data)
  },
  //更新设备箱格名称和标签
  updateBoxNameAndTag: function(data) {
    return request.post('/Equipment/updateBoxNameAndTag', data)
  }  
}

// 客户管理相关API
let clientMApi = {
  // 获取客户信息列表
  getClientList: function (data) {
    return request.post('/client/getClientList', data)
  },
  // 更新（新增/修改）客户
  updateClient: function (data) {
    return request.post('/client/updateClient', data)
  },
  // 修改客户状态
  changeClientStatus: function (data) {
    return request.post('/client/changeClientStatus', data)
  },
  // 重置客户密码
  resetClientPassword: function (data) {
    return request.post('/client/resetClientPassword', data)
  },
  // 客户权限列表
  getClientAuthList: function (data) {
    return request.post('/client/getClientAuthList', data)
  },
  // 新增客户权限
  addClientAuth: function (data) {
    return request.post('/client/addClientAuth', data)
  },

  // 获取产品销售列表
  getOutStockList: function (data) {
    return request.post('/client/getDeviceList', data)
  },
  //获取设备列表
  getDeviceType: function () {
    return request.post('/client/getDeviceCatList')
  },
  //分配公司
  editStock: function (data) {
    return request.post('/client/editStock', data)
  },
  // 更新（添加/修改）联系人信息
  updateContact: function (data) {
    return request.post('/clientOperation/updateContact', data)
  },
  // 获取联系人列表
  getContactList: function (data) {
    return request.post('/clientOperation/getContactList', data)
  },
  // 删除联系人信息
  deleteContact: function (data) {
    return request.post('/clientOperation/deleteContact', data)
  },
  // 获取运维记录列表
  getMaintenanceRecordList: function (data) {
    return request.post('/ClientOperation/getMaintenanceRecordList', data)
  },
  // 更新（添加）运维记录信息
  updateMaintenanceRecord: function (data) {
    return request.post('/ClientOperation/updateMaintenanceRecord', data)
  },
  // 获取所有公司
  getCompanyAllClient: function () {
    return request.post('/client/getCompanyAllClient')
  },
  // 获取城市/地区列表
  getAreaList: function (data) {
    return request.commonPost('/common/area', data)
  },
}

// 平台运营相关API
let platformApi = {
  // 获取缴费列表
  getPlatformList: function (data) {
    return request.post('/finance', data)
  },
  // 缴费
  getPlatPay: function (data) {
    return request.post('/finance/pay', data)
  },
  // 缴费状态
  checkPayStatus: function (data) {
    return request.post('/finance/checkPayStatus', data)
  },
  // 短信记录列表
  getSmsLog: function (data) {
    return request.post('/finance/getSmsLog', data)
  },
  // 短信重发
  smsResend: function (data) {
    return request.post('/finance/resend', data)
  },
  // 模拟短息
  sendTemp: function (data) {
    return request.post('/finance/send', data)
  },
  // 更新票据
  updateTicket: function (data) {
    return request.post('/finance/updateTicket', data)
  },
}

// 广告配置相关接口
let adApi = {
  // 获取广告列表
  getAdsList: function () {
    return request.post('/user/getAdsList')
  },
  // 添加广告
  addAd: function (data) {
    return request.post('/user/addAd', data)
  },
  // 删除广告
  deleteAd: function (data) {
    return request.post('/user/deleteAd', data)
  },
  // 获取轮播时间
  getAdsTime: function () {
    return request.post('/user/getAdsTime')
  },
  // 设置轮播时间
  setAdsTime: function (data) {
    return request.post('/user/setAdsTime', data)
  },
  // 设置广告位置
  setAdsLocation: function (data) {
    return request.post('/user/setAdsLocation', data)
  },
  // 广告绑定设备
  bindDeviceAds: function (data) {
    return request.post('/user/bindDeviceAds', data)
  },
  // 上传文件
  uploadFile: function (data) {
    return request.formDataPost('/user/uploadFile', data)
  },
  // 基本配置-获取客户热线配置
  getHotline: function () {
    return request.post('/user/getHotline')
  },
  // 基本配置-客户热线配置
  hotlineSetting: function (data) {
    return request.post('/user/hotlineSetting', data)
  },
}

//绿瘦相关
let lvApi = {
  getPosition: function () {
    return request.post('/fangdi/position')
  },
  getList: function (data) {
    return request.post('/fangdi/getList', data)
  },
  detail: function (data) {
    return request.post('/fangdi/detail', data)
  },
  //导出
  export: function (data) {
    return request.post('/fangdi/export', data)
  }
}



export {
  loginApi,
  navApi,
  mapApi,
  userApi,
  sceneApi,
  authApi,
  unmanApi,
  eSiteApi,
  bussinessApi,
  deviceApi,
  clientMApi,
  platformApi,
  adApi,
  lvApi
}



//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = BoEg
// module chunks = 1